var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8548 1.61012C13.7601 2.9494 15 5.13987 15 7.61904C15 11.6905 11.6492 14.9911 7.51512 15C3.3871 15.0089 0.0060539 11.6964 5.51965e-06 7.63094C-0.00301867 5.15178 1.2369 2.95535 3.13912 1.61309C3.49295 1.36607 3.98589 1.47024 4.19758 1.84226L4.67541 2.67857C4.85383 2.99107 4.76916 3.3869 4.47581 3.60119C3.22077 4.51785 2.41936 5.97023 2.41936 7.61606C2.41634 10.3631 4.67238 12.619 7.5 12.619C10.2702 12.619 12.5988 10.4107 12.5806 7.5863C12.5716 6.04464 11.8337 4.55654 10.5212 3.59821C10.2278 3.38392 10.1462 2.98809 10.3246 2.67857L10.8024 1.84226C11.0141 1.47321 11.504 1.36309 11.8548 1.61012ZM8.70968 7.85713V0.714285C8.70968 0.318452 8.38609 0 7.98387 0H7.01613C6.61391 0 6.29033 0.318452 6.29033 0.714285V7.85713C6.29033 8.25297 6.61391 8.57142 7.01613 8.57142H7.98387C8.38609 8.57142 8.70968 8.25297 8.70968 7.85713Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.6134112e5442e0c45d745e828aea99a8.svg";
export { ForwardRef as ReactComponent };